import getPlentyPaymentStatus from './getPlentyPaymentStatus'

const plentyLib = {
  getPlentyPaymentStatus
}

export default plentyLib
